<template>
    <div class="container my-4">
        <!-- Tarjeta para año anterior -->
        <div class="card mb-4 shadow-sm">
            <div class="card-body">
                <h5 class="card-title fw-bold text-primary">Año Anterior</h5>
                <div class="row mb-3">
                    <div class="col-md-6">
                        <label class="form-label">Selecciona año</label>
                        <select id="year1" name="year1" class="form-select shadow-sm mb-3" v-model="year1Value"
                            @change="onChangeYear1(year1Value)">
                        <option v-for="year in years" :key="year.nombre" :value="year">{{ year.nombre }}</option>
                    </select>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Selecciona mes</label>
                        <select id="month1" name="month1" class="form-select shadow-sm mb-3" v-model="month1Value"
                            @change="onChangeMonth1">
                            <option v-for="month in months1" :key="month.month_id" :value="month">{{ month.month_name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tarjeta para año actual -->
        <div class="card mb-4 shadow-sm">
            <div class="card-body">
                <h5 class="card-title fw-bold text-success">Año Actual</h5>
                <div class="row mb-3">
                    <div class="col-md-6">
                        <label class="form-label">Selecciona año</label>
                        <select id="year2" name="year2" class="form-select shadow-sm mb-3" v-model="year2Value"
                            @change="onChangeYear2(year2Value)">
                        <option v-for="year in years" :key="year.nombre" :value="year">{{ year.nombre }}</option>
                    </select>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Selecciona mes</label>
                        <select id="month2" name="month2" class="form-select shadow-sm mb-3" v-model="month2Value"
                            @change="onChangeMonth2">
                            <option v-for="month in months2" :key="month.month_id" :value="month">{{ month.month_name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <div class="btn-group">
                        <button @click="CalcularEstadistica" class="btn btn-success">Calcular datos</button>
                        <button @click="CalcularEstadisticaExcel" class="btn btn-info">Descargar EXCEL</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ComparativoIngresosGastosService } from '../../_services';
import { contabilidadService } from '../../_services';

export default {
    props: ["datosMensuales"],
    methods: {
        onChangeYear1(value) {
            console.log("Cambiando año ->")
            console.log(value.nombre)
            console.log(this.datosEntrada)
            this.months1 = ComparativoIngresosGastosService.getMonths(value.nombre, this.datosEntrada);
            this.$emit('limpiarTabla');
        },
        onChangeYear2(value) {
            console.log("Cambiando año ->")
            console.log(value.nombre)
            console.log(this.datosEntrada)
            this.months2 = ComparativoIngresosGastosService.getMonths(value.nombre, this.datosEntrada);
            this.$emit('limpiarTabla');
        },
        onChangeMonth1() {
            this.$emit('limpiarTabla');
        },
        onChangeMonth2() {
            this.$emit('limpiarTabla');
        },
        fillYears() {
            this.years = ComparativoIngresosGastosService.getYears(this.datosEntrada);
        },
        CalcularEstadistica() {
            const datos = {
                month1: this.month1Value,
                month2: this.month2Value,
                year1: this.year1Value,
                year2: this.year2Value
            };
            console.log("Datos emitidos para el cálculo de estadísticas:", datos); // Verifica que no estén vacíos
            this.$emit('getDatosEntrada', datos);
            },
        CalcularEstadisticaExcel() {

            const datos = {
                month1: this.month1Value,
                month2: this.month2Value,
                year1: this.year1Value,
                year2: this.year2Value
            };
            console.log("Datos enviados para exportar a Excel:", datos);
            this.$emit('getDatosEntradaExcel', datos);
        }
    },
    async mounted() {
        try {
            // Esperar a obtener los datos usando await
            const datos = await contabilidadService.getDatosMensuales();
            
            console.log('Datos mensuales:', datos);
            
            // Asignar los datos a las variables correspondientes
            this.datosEntrada = datos.data;  // Si los datos devueltos tienen la estructura { data: ..., mensaje: ... }
            
            // Llamar a fillYears después de obtener los datos
            this.fillYears();
            
        } catch (error) {
            console.error('Error al obtener los datos mensuales:', error);
        }
    },
    watch: {
        datosMensuales: {
            handler: 'fillYears',
            immediate: true
        }
    },
    data() {
        return {
            datosEntrada: {},
            months1: [],
            months2: [],
            years: [],
            month1Value: '',
            year1Value: '',
            month2Value: '',
            year2Value: ''
        };
    }
};
</script>

<style scoped>
.card {
    border-radius: 10px;
}

.card-body {
    padding: 1.5rem;
}

.card-title {
    margin-bottom: 1.5rem;
}

.form-select {
    border-radius: 0.375rem;
    border: 1px solid #ced4da;
}

.shadow-sm {
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, 0.075) !important;
}

.btn-group {
    margin-top: 1rem;
}
</style>